// extracted by mini-css-extract-plugin
export default {"description":"description-module__description__vaHDh","descriptionBold":"description-module__descriptionBold__gA6ub"};